class PreAndPostOpsoActions {
    static PRE_AND_POST_OPSO_REQUEST = "PRE_AND_POST_OPSO_REQUEST";
    static PRE_AND_POST_OPSO_SUCCESSFUL = "PRE_AND_POST_OPSO_SUCCESSFUL";
    static PRE_AND_POST_OPSO_FAILED = "PRE_AND_POST_OPSO_FAILED";
  
    static preAndPostOpsoRequest() {
      return {
        type: this.PRE_AND_POST_OPSO_REQUEST
      };
    }
    static preAndPostOpsoSuccessul(data) {
      return {
        type: this.PRE_AND_POST_OPSO_SUCCESSFUL,
        data
      };
    }
    static preAndPostOpsoFailed(error) {
      return {
        type: this.PRE_AND_POST_OPSO_FAILED,
        error
      };
    }
  }
  
  export default PreAndPostOpsoActions;
  